// ─────────────────────────────────────────────────────────────────────────────
// ONE MONTH-OVER-MONTH BASELINE, FOR EVERY KPI ROW THAT HAS ONE.
//
// 🔑 THE SAME RULE ON ALL THREE PAGES: "how many of these existed at the end of
// last month", counted from created_at on the ROWS THE PAGE ALREADY HAS. Partners,
// Accounts and Referrals each had their own idea of a secondary line — a static
// caption, a server-computed figure, or nothing — so the same word meant three
// things depending on which tab you were on.
//
// ⚠️ IT IS A CREATION BASELINE, NOT A SNAPSHOT OF PAST STATE. Something that
// existed last month and has since been archived is absent from BOTH numbers, so
// the delta understates churn rather than inventing it. Reconstructing historical
// status would need history tables that do not exist, and a trend assembled from
// guesses is worse than a narrower true one.
//
// ⚠️ AND IT IS DERIVED FROM THE RENDERED ROWS, NEVER FETCHED SEPARATELY. That is
// what keeps a card from disagreeing with the list beneath it, and it is why
// test-account exclusion comes free: if the endpoint filtered them out of the
// rows, they are out of the count too.
export const monthStart = () => {
  const n = new Date();
  return new Date(n.getFullYear(), n.getMonth(), 1);
};

/**
 * @param {Array} rows      the rows the page renders
 * @param {Function} [pred] optional filter, so a card can count a subset
 * @returns {number} how many existed before this month began
 */
export function countBeforeThisMonth(rows, pred) {
  const cut = monthStart();
  return (rows || []).filter((r) => {
    if (pred && !pred(r)) return false;
    // ⚠️ A ROW WITH NO created_at IS NOT COUNTED IN THE BASELINE. Treating it as
    // "existed already" would silently shrink a genuine increase; leaving it out
    // makes the delta slightly generous in the one direction that is visible.
    return r && r.created_at && new Date(r.created_at) < cut;
  }).length;
}
